<template>
  <popup
    buttonStyle="success"
    :button-text="addSuffix ((totals + 1), false) +' Option'"
    heading="New Option"
    buttonIcon="fa fa-plus"
    @save="onSave"
    @cancel="onCancel"
    :disableButton="disableButton" >


    <acquire-details :row-data="rta" :site-data="siteData" :adding="true" />


  </popup>
</template>


<script>

import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

import AcquireDetails from '@/components/requests/acquire/AcquireDetails'


export default {

  mixins: [PostMixins, NumberMixins],

  components: {
   AcquireDetails
  },


  props: {

    siteData: {
      type: Object,
      required: true
    },

    totalOptions: {
      type: Number,
      default: 1
    }

  },

  methods: {

    init () {

      this.rta.options = []
      this.rta.markers = []

      this.rta.site = this.siteData

      if (this.rta && this.site && this.site.candidate) {
        this.rta.site_id = this.site.id
        this.rta.client_id = this.site.candidate.id

        this.rta.actualLat = Number(this.site.latitude)
        this.rta.actualLng = Number(this.site.longitude)

        this.rta.optionNo = (this.totals ? this.totals : this.site.count) + 1

        if (this.site.structure) {
          this.rta.structure_id = this.site.structure.structure_id
          this.rta.structureHeight = this.site.structure.height
        }


      }

    },

    getIcon () {

      switch (this.rta.optionNo) {
        case 1: return 'static/map/green-map.png'
        case 2: return 'static/map/blue-map.png'
        case 3: return 'static/map/yellow-map.png'
        case 4: return 'static/map/red-map.png'
        case 5: return 'static/map/black-map.png'
        case 6: return 'static/map/grey-map.png'
        case 7: return 'static/map/google-map.png'
      }

    return 'static/map/outline-map.png'
    },

    updateMap (map) {
      this.rta.actualLat = Number(map.lat)
      this.rta.actualLng = Number(map.lng)
    },


    onSave () {

      this.rta.region = this.setProp(this.rta.region, this.loc[0])
      this.rta.state = this.setProp(this.rta.state, this.loc[1])
      this.rta.district = this.setProp(this.rta.district, this.loc[2])
      this.rta.subdistrict = this.setProp(this.rta.subdistrict, this.loc[3])
      this.rta.zone = this.setProp(this.rta.zone, this.loc[4])


      if (this.site.latitude && this.site.longitude) {
        this.rta.markers = [
          {infoText: 'Option ' + this.rta.optionNo,
            icon: this.getIcon(),
            type: 'option',
            distance: this.formatNumber(this.distanceInKmBetween(Number(this.site.latitude), Number(this.site.longitude), this.rta.actualLat, this.rta.actualLng) * 1000, 2),
            position: {lat: this.rta.actualLat, lng: this.rta.actualLng}}
          ]
      }

      if (this.rta.markers[0] && this.rta.markers[0].distance) {
        this.rta.distanceFromNominal = this.rta.markers[0].distance
      }

      this.saveForm(this, '/candidate', null, this.rta, (this.rta.title ? this.rta.title : 'Option') + ' #' + this.rta.optionNo, null, null, true, this.tableRef)
    },


    onCancel () {
      this.rta = {}
      this.init()
    }


  },


  watch: {
    totalOptions: function (total) {
      this.totals = total
      this.rta.optionNo = Number(total) + 1
    }
  },


  computed: {
    disableButton: function () {

      if (!this.isViewOnly()) {

        if (this.isTelco()) {
          return this.totals >= 5
        } else {
          if (this.isTowerCo()) {
            return !this.isManager('project|property|finance|management|admin') && this.totals >= 5
          }
        }

      }

    return false
    }

  },


  data () {
    return {
      guts: 12,
      loc: [],
      totals: this.totalOptions,

      rta: this.getTableStruct('site_candidates'),
      site: this.siteData,

      tableRef: 'siteCandidatesTable'

    }
  },


  created () {

    this.init()

  }

}

</script>
